export enum AuthStoreKeys {
    DeviceId = 'hellohealth_device_id',
    Auth = 'hellohealth_auth',
    SidebarIsOpen = 'sidebar_isOpen',
    SidebarUserHasToggled = 'sidebar_userHasToggled',
}